export const LANGUAGE_STORAGE_KEY = "language";
export function resolveSupportedLanguage({ browserLanguage, defaultLanguage, requestedLanguage, storedLanguage, supportedLanguages, }) {
    let nextLanguage = requestedLanguage || storedLanguage || browserLanguage || "";
    let isSupportedLanguage = supportedLanguages.includes(nextLanguage);
    if (nextLanguage && !isSupportedLanguage) {
        nextLanguage = nextLanguage.split("-")[0];
        nextLanguage =
            supportedLanguages.find((supportedLanguage) => supportedLanguage.startsWith(nextLanguage)) || "";
        isSupportedLanguage = Boolean(nextLanguage);
    }
    if (!nextLanguage || !isSupportedLanguage) {
        nextLanguage = defaultLanguage;
    }
    return nextLanguage;
}
